import React, { useState, useEffect } from 'react'

import scrollToComponent from 'react-scroll-to-component'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import GranteeProfileInfo from '../../../widgets/granteeProfileInfo/GranteeProfileInfo'
import Budget from '../../../widgets/budget/Budget'
import ApproveProposalWidget from '../../../widgets/approveProposalWidget/ApproveProposalWidget'
import OfferingApproveProposal from '../../../widgets/offeringApproveProposal/OfferingApproveProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getSchema, downloadRequestApproveFile } from '../../../redux/actions/approveProject'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import Attorney from '../../../widgets/attorney/Attorney'
import ProposeConsiderApproveProjectUploadWidget from '../../../widgets/proposeConsiderApproveProject/ProposeConsiderApproveProjectUploadWidget'
import './styles.less'
import { Message } from 'rsuite'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import ApproverCommentsWidget from '../../../widgets/approveProposalWidget/ApproverCommentsWidget'
import { getReserveDocumentRequest } from '../../../redux/actions/assetRequestManagementDetail'
import AIEvaluationResultWidget from '../../../widgets/aiEvaluation/AIEvaluationResultWidget'
import { getAiEvaluationResult } from '../../../redux/actions/aiEvaluation'

export default function ApproveProject() {
  const [section1, setSection1] = useState()
  const [section2, setSection2] = useState()
  const [section3, setSection3] = useState()

  useEffect(() => {
    if (location.search === '?1') {
      scrollToComponent(section1, { offset: -20, align: 'top', duration: 500 })
    } else if (location.search === '?2') {
      scrollToComponent(section2, { offset: -20, align: 'top', duration: 500 })
    } else if (location.search === '?3') {
      scrollToComponent(section3, { offset: -20, align: 'top', duration: 500 })
    }
  }, [location.search, section1])

  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)

  const [isAssetRequestPdfError, setIsAssetRequesstPdfError] = useState(false)
  const [previewAssetRequestPdf, setPreviewAssetRequesstPdf] = useState()
  const [isLoadingAssetRequestPDF, setIsLoadingAssetRequesstPDF] = useState(false)

  const [proposalEvaluationResult, setProposalEvaluationResult] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
    projectId && handleGetProposalEvaluationResult()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchema(projectId)
      setSchema(_schema)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  const handleGetProposalEvaluationResult = async () => {
    try {
      const response = await getAiEvaluationResult(projectId)

      if (response) {
        setProposalEvaluationResult(response)
      }
    } catch (e) {}
  }

  const handleGetAssetRequestFile = async (id) => {
    startLoading()
    setIsAssetRequesstPdfError(false)
    setIsLoadingAssetRequesstPDF(true)
    try {
      const response = await getReserveDocumentRequest('', id)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewAssetRequesstPdf(response)
        setIsAssetRequesstPdfError(false)
      } else {
        setIsAssetRequesstPdfError(true)
      }
    } catch (e) {
      setIsAssetRequesstPdfError(true)
    }
    setIsLoadingAssetRequesstPDF(false)
    doneLoading()
  }

  const handleGetFile = async (id) => {
    startLoading()
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await downloadRequestApproveFile(id)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      setIsPdfError(true)
    }
    setIsLoadingPDF(false)
    doneLoading()
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <div className="approve-project">
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />
        <div className="approve-project__section">
          <ProjectBasicInfo schema={schema.projectInfo} />
        </div>
        <div
          ref={(section) => {
            setSection1(section)
          }}
          className="approve-project__section"
        >
          <h5>{schema.budgetHeader}</h5>
          <br />
          <Budget
            schema={schema}
            isEditable={false}
            onClick={() => {}}
            isCollapseAllTableRow={true}
          />
        </div>
        <div
          ref={(section) => {
            setSection2(section)
          }}
          className="approve-project__section"
        >
          <h5>{schema.granteeProfileHeader}</h5>
          <br />
          <GranteeProfileInfo schema={schema.granteeProfile} />
        </div>
        <div
          ref={(section) => {
            setSection3(section)
          }}
          className="approve-project__section"
        >
          <h5>{schema.approveProposalHeader + '-----'}</h5>
          <br />
          {schema.attorney && (
            <>
              <Attorney showCommandButton={false} schema={schema?.attorney} />
              <br />
            </>
          )}
          {schema.uploadDocuments && (
            <>
              <ProposeConsiderApproveProjectUploadWidget
                showCommandButton={false}
                schema={schema?.uploadDocuments}
              />
              <br />
            </>
          )}

          {schema.approverComment && (
            <ApproverCommentsWidget approverComment={schema.approverComment} />
          )}

          {(schema.approveProposal || schema.offeringApproveProposal) && (
            <div style={{ marginTop: 20 }}>
              <AIEvaluationResultWidget
                schema={proposalEvaluationResult}
                shaded
                showDetail={false}
              />
            </div>
          )}
          {/* คนสุดท้าย */}
          {schema.approveProposal && (
            <>
              <br />
              <ApproveProposalWidget
                schema={schema.approveProposal}
                approverComment={schema.approverComment}
              />
            </>
          )}

          {/* ขั้นต้น */}
          {schema.offeringApproveProposal && (
            <>
              <br />
              <OfferingApproveProposal
                schema={schema.offeringApproveProposal}
                approverComment={schema.approverComment}
              />
            </>
          )}
        </div>
      </div>

      {(schema?.offeringApproveProposal?.assetWarningMessage ||
        schema?.approveProposal?.assetWarningMessage) && (
        <>
          {isAssetRequestPdfError ? (
            <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
          ) : (
            <PdfRenderWidgets
              header={'ครุภัณฑ์หมุนเวียน'}
              file={previewAssetRequestPdf}
              isLoading={isLoadingAssetRequestPDF}
              fileName={'ครุภัณฑ์หมุนเวียน'}
              onReload={() => {
                handleGetAssetRequestFile(projectId)
              }}
              loadingMessage={'กรุณารอสักครู่ ระบบกำลังสร้าง PDF ครุภัณฑ์หมุนเวียน...'}
              firstExpandToReload={true}
            />
          )}
        </>
      )}

      {isPdfError ? (
        <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
      ) : (
        <PdfRenderWidgets
          header={'แบบขออนุมัติและจัดทำสัญญา'}
          file={previewPdf}
          isLoading={isLoadingPDF}
          fileName={'แบบขออนุมัติและจัดทำสัญญา'}
          onReload={() => {
            handleGetFile(projectId)
          }}
          loadingMessage={'กรุณารอสักครู่ ระบบกำลังสร้าง PDF แบบขออนุมัติและจัดทำสัญญา...'}
          firstExpandToReload={true}
        />
      )}
      <br />
    </SidebarProposal>
  )
}
